import { Employee } from '.';
import { apiFetch, HTTPMethod } from '../fetch';

export const getEmployees = (): Promise<Employee[]> =>
  apiFetch('/UserEmployees', undefined, HTTPMethod.GET);
